import { render, staticRenderFns } from "./TaskResult.vue?vue&type=template&id=389746d2&scoped=true"
import script from "./TaskResult.vue?vue&type=script&lang=js"
export * from "./TaskResult.vue?vue&type=script&lang=js"
import style0 from "./TaskResult.vue?vue&type=style&index=0&id=389746d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389746d2",
  null
  
)

export default component.exports